package top.wcpe.allincore.ui.web.input

internal data class WebKeyTiming(val action: WebKeyAction, val holdMs: Long)

internal class WebKeyHoldTracker {
    private val pressedAt = mutableMapOf<String, Long>()

    fun keyDown(code: String, nowMs: Long, repeat: Boolean): WebKeyTiming {
        val startedAt = pressedAt.getOrPut(code) { nowMs }
        if (!repeat) return WebKeyTiming(WebKeyAction.PRESS, 0)
        return WebKeyTiming(WebKeyAction.REPEAT, elapsed(nowMs, startedAt))
    }

    fun keyUp(code: String, nowMs: Long): WebKeyTiming {
        val startedAt = pressedAt.remove(code) ?: return WebKeyTiming(WebKeyAction.RELEASE, 0)
        return WebKeyTiming(WebKeyAction.RELEASE, elapsed(nowMs, startedAt))
    }

    fun isPressed(code: String): Boolean = code in pressedAt

    fun pressedCodes(): Set<String> = pressedAt.keys.toSet()

    fun clear() {
        pressedAt.clear()
    }

    private fun elapsed(nowMs: Long, startedAt: Long): Long = (nowMs - startedAt).coerceAtLeast(0)
}
